import { useBreakpoints } from '../../../../../../bookings/util/useBreakpoints';
import {
  LinkTrackingData,
  SearchCardArea,
} from '../../../../../../common/AnalyticsContext/LinkTracking';
import { makeAppProfileDeepLink } from '../../../../../urls';
import { AppointmentInfo, AppointmentsView, CallToAction, CtaLink } from './Appointments.styles';
import { CtaLinkWithTapTarget } from './CtaLinkWithExperiment';

interface Props {
  trackingData?: LinkTrackingData;
  id: string;
  type: 'practice' | 'practitioner';
}

export const DownloadApp = ({ trackingData, type, id }: Props) => {
  const tracking = {
    ...trackingData,
    searchCardArea: SearchCardArea.DOWNLOAD_APP_BUTTON,
  };

  const breakpoints = useBreakpoints();

  return (
    <AppointmentsView>
      <AppointmentInfo>
        Already registered with this practice? Download the app to book.
      </AppointmentInfo>

      {breakpoints.Small ? (
        <CtaLinkWithTapTarget to={makeAppProfileDeepLink(type, id)} trackingData={tracking}>
          <CallToAction>Download App</CallToAction>
        </CtaLinkWithTapTarget>
      ) : (
        <CtaLink to={makeAppProfileDeepLink(type, id)} trackingData={tracking}>
          <CallToAction>Download App</CallToAction>
        </CtaLink>
      )}
    </AppointmentsView>
  );
};
